
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("6wxEl", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $4bffd55cbb00ede2$export$2cd8252107eb640b; });
// Panels

var $jG4hL = parcelRequire("jG4hL");
/**
 * Utility to select all panel's content blocks.
 * Simplified version to use instead of bootstrap.Collapse()
 *
 * @param {String} selector - panel selector to get elements set with jQuery
 * @param {String} panelClass - panel className as BEM CSS block ('panel' is default)
 */ var $4bffd55cbb00ede2$var$attachPanelsHandler = function attachPanelsHandler(selector) {
    var panelClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "panel";
    var targets = Array.from(document.querySelectorAll(selector));
    targets.forEach((elem)=>{
        var panelBtn = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(elem).prev();
        var panelBlock = panelBtn.parent();
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(elem).hasClass("show")) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(elem).slideUp(500).removeClass("show");
            panelBtn.removeClass(panelClass + "__btn--open");
            panelBtn.children("button").attr("aria-expanded", "false");
            if (panelBlock.hasClass("active")) panelBlock.removeClass("active");
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(elem).slideDown(500).addClass("show");
            panelBtn.addClass(panelClass + "__btn--open");
            panelBtn.children("button").attr("aria-expanded", "true");
            if (panelBlock.hasClass("active")) panelBlock.addClass("active");
        }
    });
};
var $4bffd55cbb00ede2$export$2cd8252107eb640b = ()=>{
    //  Panels
    if (document.querySelector(".panel")) (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))("section .panel").on("click", (ev)=>{
        var elem = ev.target;
        var btn = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(elem).closest(".panel__btn");
        if (btn.length) {
            var target = btn.find("button[data-target]").data("target");
            $4bffd55cbb00ede2$var$attachPanelsHandler(target);
        }
    });
};

});


//# sourceMappingURL=panel.module.577fbc1d.js.map
